var feeJS = feeJS || {};
feeJS.execDocReady = {}



feeJS.execOnLoad = {
  setScrollbarWidth: '',
}



feeJS.execResize = {
  setScrollbarWidth: '',
}